/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-23 17:59:49
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-05-01 21:02:22
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorButton/tool.ts
 */

import {
  convertSpecificError,
  generateCollapseErrorMsgDisplay,
  generateCollapseOpen,
} from '@/src/constrains/SalesChannelPreviewPageComponents/tools';
import { errCodesMap } from '@/src/error/code';

export enum ButtonType {
  OUTLINE_FILLED = 'OUTLINE_FILLED',
  TEXT = 'TEXT',
}

export const generateNewButton = (name: string) => {
  return {
    name,
    type: ButtonType.OUTLINE_FILLED,
    ...defaultOutlineButtonProps,
  };
};

export const defaultOutlineButtonProps = {
  paddingLeftRight: 60,
  height: 48,
  radius: 0,
  outlineStrokeWidth: 0,
  regularStyle: {
    textFont: 'Open Sans',
    fontSize: 14,
    bold: true,
    italic: false,
    underline: false,
    textColor: '#ffffff',
    outlineColor: '#000000',
    filledColor: '#000000',
    enableShadow: false,
    shadowStyle: {
      shadowColor: 'rgba(0,0,0,0.5)',
      blur: 4,
      spread: 0,
      xoffset: 2,
      yoffset: 2,
    },
  },
  hoverStyle: {
    textFont: 'Open Sans',
    fontSize: 14,
    bold: true,
    italic: false,
    underline: false,
    textColor: '#ffffff',
    outlineColor: '#000000',
    filledColor: '#000000',
    enableShadow: false,
    shadowStyle: {
      shadowColor: 'rgba(0,0,0,0.5)',
      blur: 4,
      spread: 0,
      xoffset: 2,
      yoffset: 2,
    },
  },
};

export const defaultTextButtonProps = {
  regularStyle: {
    textFont: 'Open Sans',
    fontSize: 14,
    bold: true,
    italic: false,
    outline: false,
    textColor: '#000000',
  },
  hoverStyle: {
    textFont: 'Open Sans',
    fontSize: 14,
    bold: true,
    italic: false,
    outline: false,
    textColor: '#000000',
  },
};

export const buttonValidation = (x: any) => {
  const specificError = {};
  if (!x?.name) {
    specificError['name'] = [];
    specificError['name'].push(errCodesMap[999978]);
  }
  if (!x?.regularStyle?.fontSize) {
    specificError['regularStyle.fontSize'] = [];
    specificError['regularStyle.fontSize'].push(errCodesMap[999978]);
  }
  if (!x?.hoverStyle?.fontSize) {
    specificError['hoverStyle.fontSize'] = [];
    specificError['hoverStyle.fontSize'].push(errCodesMap[999978]);
  }
  if (
    x?.regularStyle?.enableShadow &&
    !x?.regularStyle?.shadowStyle?.blur &&
    x?.regularStyle?.shadowStyle?.blur !== 0
  ) {
    specificError['regularStyle.shadowStyle.blur'] = [];
    specificError['regularStyle.shadowStyle.blur'].push(errCodesMap[999978]);
  }
  if (
    x?.regularStyle?.enableShadow &&
    !x?.regularStyle?.shadowStyle?.spread &&
    x?.regularStyle?.shadowStyle?.spread !== 0
  ) {
    specificError['regularStyle.shadowStyle.spread'] = [];
    specificError['regularStyle.shadowStyle.spread'].push(errCodesMap[999978]);
  }
  if (
    x?.regularStyle?.enableShadow &&
    !x?.regularStyle?.shadowStyle?.xoffset &&
    x?.regularStyle?.shadowStyle?.xoffset !== 0
  ) {
    specificError['regularStyle.shadowStyle.xoffset'] = [];
    specificError['regularStyle.shadowStyle.xoffset'].push(errCodesMap[999978]);
  }
  if (
    x?.regularStyle?.enableShadow &&
    !x?.regularStyle?.shadowStyle?.yoffset &&
    x?.regularStyle?.shadowStyle?.yoffset !== 0
  ) {
    specificError['regularStyle.shadowStyle.yoffset'] = [];
    specificError['regularStyle.shadowStyle.yoffset'].push(errCodesMap[999978]);
  }
  if (
    x?.hoverStyle?.enableShadow &&
    !x?.hoverStyle?.shadowStyle?.blur &&
    x?.hoverStyle?.shadowStyle?.blur !== 0
  ) {
    specificError['hoverStyle.shadowStyle.blur'] = [];
    specificError['hoverStyle.shadowStyle.blur'].push(errCodesMap[999978]);
  }
  if (
    x?.hoverStyle?.enableShadow &&
    !x?.hoverStyle?.shadowStyle?.spread &&
    x?.hoverStyle?.shadowStyle?.spread !== 0
  ) {
    specificError['hoverStyle.shadowStyle.spread'] = [];
    specificError['hoverStyle.shadowStyle.spread'].push(errCodesMap[999978]);
  }
  if (
    x?.hoverStyle?.enableShadow &&
    !x?.hoverStyle?.shadowStyle?.xoffset &&
    x?.hoverStyle?.shadowStyle?.xoffset !== 0
  ) {
    specificError['hoverStyle.shadowStyle.xoffset'] = [];
    specificError['hoverStyle.shadowStyle.xoffset'].push(errCodesMap[999978]);
  }
  if (
    x?.hoverStyle?.enableShadow &&
    !x?.hoverStyle?.shadowStyle?.yoffset &&
    x?.hoverStyle?.shadowStyle?.yoffset !== 0
  ) {
    specificError['hoverStyle.shadowStyle.yoffset'] = [];
    specificError['hoverStyle.shadowStyle.yoffset'].push(errCodesMap[999978]);
  }
  return {
    specificError,
    hasError: convertSpecificError(specificError).length > 0,
    generalError: [],
  };
};

export const convertDataFromServerToRedux = (res: any) => {
  const {
    hasError,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    buttons,
  } = res;
  const _isNew = !uuid;
  const ids = buttons.map((v) => v.uuid).filter((v) => v);
  const collapseOpen = generateCollapseOpen(ids);
  const collapseErrorMsgDisplay = generateCollapseErrorMsgDisplay(ids, !_isNew);
  return {
    hasError,
    collapseErrorMsgDisplay,
    collapseOpen,
    contentUuid,
    salesChannelContent: salesChannelContent || {},
    salesChannelName,
    modifiedDate,
    createdDate,
    uuid,
    buttons,
  };
};

export const convertDataFromReduxToServer = (state: any) => {
  const {
    hasError,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    buttons,
  } = state;
  const list = Array.isArray(buttons)
    ? buttons.map((b) => {
        if (b.isNew) {
          return {
            ...b,
            uuid: null,
          };
        } else {
          return b;
        }
      })
    : [];
  return {
    hasError,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    buttons: list,
  };
};
